import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { borderGrey } from 'common/constants/colors';
import { API_ITEM_PROPTYPE } from 'common/constants/commonPropTypes';
import PaneHeader from './PaneHeader';
import PaneItem from './PaneItem';
import AddOrEditItemModal from './ItemModal';

const AdminPane = ({ paneName, paneItems, onSelectItem, selectedItem, parentItem }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});

  return (
    <div style={{ borderRight: `solid 1px ${borderGrey}`, width: '25vw' }}>
      <PaneHeader
        onAdd={parentItem || paneName === 'Genre'
          ? () => {
            setModalOpen(true);
            setModalData({});
          } : null}
        paneName={paneName}
      />
      <div style={{ margin: '10px' }}>
        {paneItems
                    && paneItems.map(item => (
                      <PaneItem
                        isSelected={selectedItem === item}
                        item={item}
                        key={item.name}
                        onClick={() => onSelectItem(item)}
                        onEdit={e => {
                          e.stopPropagation();

                          setModalOpen(true);
                          setModalData(selectedItem);
                        }}
                      />
                    ))}
      </div>
      <AddOrEditItemModal
        data={modalData}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        parentItem={parentItem}
        type={paneName}
      />
    </div>
  );
};
AdminPane.propTypes = {
  paneName: PropTypes.string.isRequired,
  paneItems: PropTypes.arrayOf(API_ITEM_PROPTYPE),
  onSelectItem: PropTypes.func.isRequired,
  selectedItem: API_ITEM_PROPTYPE,
  parentItem: API_ITEM_PROPTYPE,
};
AdminPane.defaultProps = { paneItems: [], selectedItem: null, parentItem: null };

export default AdminPane;
